import { router } from 'expo-router'

export type CartItemToDeleteType = 'product' | 'container'

export const setCartItemToDeleteId = (id: string, type: CartItemToDeleteType = 'product') =>
    router.setParams({ cartItemToDeleteId: id, cartItemToDeleteType: type })

export const unsetCartItemToDeleteId = () =>
    router.setParams({ cartItemToDeleteId: undefined, cartItemToDeleteType: undefined })
